export default __webpack_public_path__ + "static/media/microscope.8a2a6a70.png";